// extracted by mini-css-extract-plugin
export default {"custom-select-label":"customSelectDropDown_custom-select-label__bmEjq"};